import theme from '@/config/theme';
import styled from 'vue-styled-components';

export const Wrapper = styled.div`
  .alert, .error {
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 0.2rem;
    color: ${theme.colors.supportAlert};
    margin-bottom: 0.5rem;

    svg {
      width: 2.5rem;
      height: 2.5rem;
    }
  }

  .error {
    font-size: 2.2rem;
    color: ${theme.colors.supportError};
  }

  .link {
    color: ${theme.colors.primary};

    :hover {
      text-decoration: underline;
    }
  }

  .observerContent {
    display: flex;
    width: 100%;
    justify-content: center;
  }

  .errorMessage {
    font-size: 0.8rem;
    color: ${theme.colors.supportErrorDark};
  }

  .linkDoc {
    color: ${theme.colors.primary};
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 0.5rem;
  }

  .providerContent {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    row-gap: .2rem;
  }
`;

export const Main = styled.main`
  padding: 140px 0 2rem 0;
  height: 100%;
  width: 100%;
`;

export const Container = styled.div`
  margin: auto;
  min-width: 240px;
  max-width: 974px;
  width: 150%;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 1.5rem;
  padding: 1rem 2rem;
  border-radius: ${theme.border.radius.small};
  box-shadow: ${theme.shadow.lv1};
  background-color: #fff;

  .contentButtonBack {
    width: 100%;
    display: grid;
    justify-content: start;

    button {
      width: 35px;
    }
  }

  .stepsContent,
  .providerContainer,
  button {
    width: 100%;
  }

  .loadingContainer {
    position: relative;
    width: 100%;
    height: 50px;
  }
`;

export const Content = styled.div`
  width: 100%;
  gap: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  .observerContainer {
    width: 65%;
    display: block;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  row-gap: 1.5rem;
`;
